module.exports = __webpack_public_path__ + "img/icon-notif.ca4f4c85.svg";